import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const QuickActions = ({ notifications, onMarkAllRead }) => {
  const navigate = useNavigate();

  const quickActionItems = [
    {
      id: 'browse',
      title: 'Browse Tours',
      description: 'Discover new adventures',
      icon: 'Compass',
      color: 'text-primary',
      bgColor: 'bg-primary/10',
      action: () => navigate('/homepage')
    },
    {
      id: 'bookings',
      title: 'My Bookings',
      description: 'Manage your trips',
      icon: 'Calendar',
      color: 'text-accent',
      bgColor: 'bg-accent/10',
      action: () => navigate('/booking-flow')
    },
    {
      id: 'profile',
      title: 'Profile Settings',
      description: 'Update your information',
      icon: 'Settings',
      color: 'text-secondary',
      bgColor: 'bg-secondary/10',
      action: () => navigate('/profile-management')
    },
    {
      id: 'support',
      title: 'Customer Support',
      description: 'Get help when you need it',
      icon: 'MessageCircle',
      color: 'text-success',
      bgColor: 'bg-success/10',
      action: () => {}
    }
  ];

  return (
    <div className="space-y-6">
      {/* Quick Actions Grid */}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {quickActionItems?.map((item) => (
          <button
            key={item?.id}
            onClick={item?.action}
            className="bg-card rounded-xl p-4 border border-border hover:shadow-lg transition-all duration-200 hover:scale-105 text-left group"
          >
            <div className={`p-2 rounded-lg ${item?.bgColor} w-fit mb-3 group-hover:scale-110 transition-transform`}>
              <Icon name={item?.icon} size={20} className={item?.color} />
            </div>
            <h3 className="font-semibold text-foreground mb-1 text-sm">{item?.title}</h3>
            <p className="text-xs text-muted-foreground">{item?.description}</p>
          </button>
        ))}
      </div>
      {/* Notifications Panel */}
      <div className="bg-card rounded-xl border border-border">
        <div className="p-4 border-b border-border">
          <div className="flex items-center justify-between">
            <h3 className="font-semibold text-foreground">Recent Notifications</h3>
            <Button
              variant="ghost"
              size="sm"
              onClick={onMarkAllRead}
              iconName="Check"
              iconPosition="left"
            >
              Mark All Read
            </Button>
          </div>
        </div>
        
        <div className="max-h-64 overflow-y-auto">
          {notifications?.length === 0 ? (
            <div className="p-6 text-center">
              <Icon name="Bell" size={32} className="text-muted-foreground mx-auto mb-2" />
              <p className="text-muted-foreground">No new notifications</p>
            </div>
          ) : (
            <div className="divide-y divide-border">
              {notifications?.map((notification) => (
                <div key={notification?.id} className="p-4 hover:bg-muted/50 transition-colors">
                  <div className="flex items-start space-x-3">
                    <div className={`p-1 rounded-full ${
                      notification?.type === 'booking' ? 'bg-primary/10' :
                      notification?.type === 'payment' ? 'bg-success/10' :
                      notification?.type === 'reminder'? 'bg-warning/10' : 'bg-muted'
                    }`}>
                      <Icon 
                        name={
                          notification?.type === 'booking' ? 'Calendar' :
                          notification?.type === 'payment' ? 'CreditCard' :
                          notification?.type === 'reminder'? 'Clock' : 'Bell'
                        } 
                        size={14} 
                        className={
                          notification?.type === 'booking' ? 'text-primary' :
                          notification?.type === 'payment' ? 'text-success' :
                          notification?.type === 'reminder'? 'text-warning' : 'text-muted-foreground'
                        }
                      />
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-sm font-medium text-foreground mb-1">
                        {notification?.title}
                      </p>
                      <p className="text-xs text-muted-foreground mb-1">
                        {notification?.message}
                      </p>
                      <p className="text-xs text-muted-foreground">
                        {new Date(notification.timestamp)?.toLocaleString()}
                      </p>
                    </div>
                    {!notification?.read && (
                      <div className="w-2 h-2 bg-primary rounded-full flex-shrink-0 mt-2"></div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default QuickActions;